export default __webpack_public_path__ + "static/JoinBg-78db8cf35dacc6992247e74c40bc4afe.png";